import { Injectable } from '@angular/core';
import { GestureConfig, HammerManager } from '@angular/material/core';

@Injectable()
export class CustomGestureConfig extends GestureConfig {
  buildHammer(element: HTMLElement) {
    const mc = <HammerManager>super.buildHammer(element);

    mc.set({ touchAction: 'pan-y' });
    (mc as any).get('swipe').set({ velocity: 0.3, threshold: 10 });

    return mc;
  }
}
